/**
 * Support (`/support?lottery=&entry=&win=` form, `/support/cases/:ref` follow-up) — §11.4: case ID, owner, next
 * update time and appeal path; the Idempotency-Key is kept across retries (§4.4).
 */
import type { RouteObject } from 'react-router';
import { lazyRoute } from '../lazy';

const SupportPage = lazyRoute(() => import('./SupportPage'));
const SupportCasePage = lazyRoute(() => import('./SupportCasePage'));

export const supportRoutes: RouteObject[] = [
  { path: '/support', element: <SupportPage /> },
  { path: '/support/cases/:ref', element: <SupportCasePage /> },
];
